import { createReducer } from "@reduxjs/toolkit";

import { renameWidgets } from "legacy/actions/controlActions";
import { stopEvaluation } from "legacy/actions/evaluationActions";
import {
  createPageSuccess,
  deletePageInit,
  updateCurrentRoute,
} from "legacy/actions/pageActions";
import type { PageListPayload } from "legacy/constants/ReduxActionConstants";
import { PAGE_WIDGET_ID } from "legacy/constants/WidgetConstants";

type ResponsiveCanvasMetadataState = {
  unscaledWidth: number;
  canvasScaleFactor: number;
  scaledWidth: number;
  scrollbarWidth: number;
};

const initialState: PageListReduxState = {
  pages: [],
  responsiveCanvasMetadata: {
    unscaledWidth: Number.MAX_SAFE_INTEGER,
    canvasScaleFactor: 1,
    scaledWidth: Number.MAX_SAFE_INTEGER,
    scrollbarWidth: 0,
  },
};

const pageListReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(stopEvaluation, () => initialState)
    .addCase(deletePageInit, (state, action) => {
      const pages = [
        ...state.pages.filter((page) => page.pageId !== action.payload.pageId),
      ];
      return {
        ...state,
        pages,
      };
    })
    .addCase(createPageSuccess, (state, action) => {
      const { pageId, pageName } = action.payload;
      return { ...state, pages: [...state.pages, { pageId, pageName }] };
    })
    .addCase(updateCurrentRoute, (state, action) => {
      if (!action.payload) {
        return state;
      }
      if (action.payload && "pageId" in action.payload.routeDef) {
        return {
          ...state,
          currentPageId: action.payload?.routeDef?.pageId,
        };
      }
      return state;
    })
    .addCase(renameWidgets, (state, action) => {
      const match = action.payload.updates.find(
        (update) =>
          update.widgetId === PAGE_WIDGET_ID &&
          update.propertyName === "widgetName",
      );
      if (match) {
        const currentPage = state.pages.find(
          (page) => page.pageId === state.currentPageId,
        );
        if (currentPage) {
          currentPage.pageName = match.propertyValue as string;
        }
      }
    }),
);

export interface PageListReduxState {
  pages: PageListPayload;
  applicationId?: string;
  currentPageId?: string;
  responsiveCanvasMetadata: ResponsiveCanvasMetadataState;
}

export default pageListReducer;
